import { MainBody } from './main-body';

// Shop types
export interface Shop {
  id: string | number;
  name?: string;
  code?: string;
  main_body_id?: string | number;
  main_body?: MainBody;
  description?: string;
  status?: number;
  server_id?: number;
  platform?: string;
  contact_phone?: string;
  address?: string;
  created_at?: string;
  updated_at?: string;
}

export const ShopLabels = {
  name: '店铺名称',
  code: '店铺代码',
  main_body_id: '运营主体',
  description: '描述',
  status: '状态',
  server_id: '服务器ID',
  platform: '平台类型',
  contact_phone: '联系电话',
  address: '地址',
};
